import React from 'react';
import { wrapDisplayName } from 'recompose';
import { connect } from 'react-redux';
import fp from 'lodash/fp';
import _ from 'lodash';
import { getDiscountValue, mapState } from '@deerplusofficial/pos-helper';

const calculateSubtotal = fp.compose(
  fp.sum,
  fp.map(({ retail_price, unit_price, quantity }) => {
    const price = unit_price || retail_price;
    return price * quantity;
  })
);

const calculateSubtotalWithDiscount = fp.compose(
  fp.sum,
  fp.map(({ retail_price, unit_price, quantity, discount }) => {
    const price = unit_price || retail_price;
    const discountValue = getDiscountValue({
      price,
      quantity,
      formattedValue: discount.formattedValue,
      isDiscountPlan: discount.type === 1,
    });

    return price * quantity - discountValue || 0;
  })
);

export default config => Component => {
  return connect(mapState(['cart', 'order']))(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithSubtotal');

      getSubtotal = (discount = false) => {
        const {
          cart: { items },
          order: { customPrice },
        } = this.props;

        if (_.size(items) === 0) return customPrice;

        const calculator = discount
          ? calculateSubtotalWithDiscount
          : calculateSubtotal;

        return calculator(items);
      };

      render() {
        const props = _.omit(this.props, ['cart', 'order']);

        return <Component getSubtotal={this.getSubtotal} {...props} />;
      }
    }
  );
};



// WEBPACK FOOTER //
// ./src/assist/withSubtotal.js